import React from "react";

import Submit from "../HandleSubmit";

import styles from "./main-timer-display.module.scss";
import fonts from "../../../../css/components/fonts.scss";

const quarterStartSubmit = async (options) => {
    const {
        quarterParams,
        matchData,
        totalTimePlayed,
        matchId,
        setMatchData,
        formatApiData,
        homePlayers,
        awayPlayers,
        setEventsToShow,
        sides,
    } = options;
    const { matchPosts } = matchData;

    let period;

    switch (quarterParams.id) {
        case "Q1":
            period = 1;
            break;
        case "Q2":
            period = 2;
            break;
        case "Q3":
            period = 3;
            break;
        case "Q4":
            period = 4;
            break;
        default:
            period = null;
            break;
    }

    let payload = {
        type: "Periods",
        orderIndex: matchPosts?.length,
        isLive: true,
        minute: totalTimePlayed ? Math.ceil(totalTimePlayed / 60) : 1,
        quarter: period,
    };

    let doesEventExist = false;
    switch (quarterParams.id) {
        case "Q1":
            doesEventExist = matchPosts.some((post) => post.postType === 1);
            payload = {
                matchPosts: [
                    ...matchPosts,
                    {
                        ...payload,
                        postType: 1,
                    },
                ],
            };
            break;
        case "Q2":
            doesEventExist = matchPosts.some((post) => post.postType === 3);
            payload = {
                matchPosts: [
                    ...matchPosts,
                    {
                        ...payload,
                        postType: 3,
                    },
                ],
            };
            break;
        case "Q3":
            doesEventExist = matchPosts.some((post) => post.postType === 5);
            payload = {
                matchPosts: [
                    ...matchPosts,
                    {
                        ...payload,
                        postType: 5,
                    },
                ],
            };
            break;
        case "Q4":
            doesEventExist = matchPosts.some((post) => post.postType === 7);
            payload = {
                matchPosts: [
                    ...matchPosts,
                    {
                        ...payload,
                        postType: 7,
                    },
                ],
            };
            break;
    }

    if (!doesEventExist) {
        await Submit(matchId, matchData, payload, setMatchData)
            .then((data) => {
                formatApiData(
                    data,
                    sides,
                    setEventsToShow,
                    ...homePlayers,
                    ...awayPlayers
                );
            })
            .catch((e) => console.error(e.message));
    }
};

const timerSubmit = async (
    hasStarted,
    timePlayed,
    matchId,
    matchData,
    setMatchData
) => {
    const tickerStatus = hasStarted ? 0 : 1;
    const tickerSeconds = timePlayed;
    const tickerTimestamp = Date.now();
    const update = {
        tickerTimer: true,
        dhbMatchTimers: {
            tickerStatus,
            tickerSeconds,
            tickerTimestamp,
        },
    };
    await Submit(matchId, matchData, update, setMatchData);
};

const StartStopButton = ({
    quarterParams,
    setTimersPerQuarter,
    setMatchStatus,
    matchId,
    matchData,
    setMatchData,
    matchStatus,
    totalTimePlayed,
    formatApiData,
    homePlayers,
    awayPlayers,
    setEventsToShow,
    sides,
}) => {
    const hasStarted = quarterParams?.quarterStarted;
    const { timePlayed } = quarterParams;
    const { quarter4, matchHasShootout, matchPosts } = matchData;

    //is shootout tab active
    const penaltyEvent = matchPosts?.some(
        (post) => post.additionalData === "Start of a shootout"
    );
    const isShootout = quarter4 && matchHasShootout && penaltyEvent;
    return (
        <button
            className={`${styles["timer-button"]} ${fonts.fs30}`}
            style={{
                backgroundColor: hasStarted ? "red" : "green",
                ...(isShootout
                    ? {
                          opacity: "0.3",
                          pointerEvents: "none",
                          cursor: "not-allowed",
                          marginLeft: "auto",
                      }
                    : {}),
                ...(matchStatus > 3 || quarter4
                    ? { opacity: "0.3", pointerEvents: "none" }
                    : {}),
            }}
            onClick={async () => {
                setTimersPerQuarter((details) => {
                    return {
                        ...details,
                        [quarterParams?.id]: {
                            ...details[quarterParams?.id],
                            quarterStopped:
                                !details[quarterParams?.id]["quarterStopped"],
                            quarterStarted:
                                !details[quarterParams?.id]["quarterStarted"],
                            // quarterEnded: !details[quarterParams?.id]["quarterEnded"],
                        },
                    };
                });
                setMatchStatus(3);

                await timerSubmit(
                    hasStarted,
                    timePlayed,
                    matchId,
                    matchData,
                    setMatchData
                );

                if (!hasStarted) {
                    await quarterStartSubmit({
                        quarterParams,
                        matchData,
                        totalTimePlayed,
                        matchId,
                        setMatchData,
                        formatApiData,
                        homePlayers,
                        awayPlayers,
                        setEventsToShow,
                        sides,
                    });
                }
            }}
        >
            {hasStarted ? "STOP" : "START"}
        </button>
    );
};

export default StartStopButton;
